import React from "react"
import {FieldGlistGroupProps} from "../../../../render/glist/glist-group";



export default function FieldColor_GlistGroupModern(props:FieldGlistGroupProps) {

    // Notice: value may be 'null' (string) because while grouping null value is automatically converted to string

    // const option = this._getOption(value);
    const option = props.field._getOption(props.data.value)


    const groupColor:any = _.get(option, 'value', null);
    const groupName = ""

    const groupNameClasses = Classes("ui5-group-by-text-2", {
        ['gd-c-{0}'.f(groupColor)]: !!groupColor,
        ['text-color-white']: !groupColor,
    });

    return <div className={groupNameClasses} style={{width: '28px', borderRadius:'14px'}}>{groupName}</div>;

}
